"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getAtom(nucleus) {
    return nucleus?.replace(/\d/g, '') || '';
}
exports.default = getAtom;
